/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    export interface ICalendarServiceClient {
        saveStudentEvent: (newEvent: IEvent) => ng.IPromise<boolean>;
        getAllEvents: () => ng.IPromise<any>;
        updateStudentEvent: (event: IEvent) => ng.IPromise<boolean>;
        deleteStudentEvent: (eventId: string) => ng.IPromise<boolean>;
    }

    export class CalendarServiceClient implements ICalendarServiceClient {
        static serviceId: string = "calendarServiceClient";
        constructor(private Restangular: Restangular.IService, private common: ICommonFactory, private $http: ng.IHttpService) {
        }

        public saveStudentEvent(newEvent: EventDetails) {

            var event: IEvent = {
                name: newEvent.name,
                category: newEvent.category,
                start: newEvent.start,
                end: newEvent.end,
                allDayEvent: newEvent.allDayEvent,
                description: newEvent.description
            }
            var deferred = this.common.$q.defer<boolean>();


            this.Restangular.all("Calendar/saveStudentEvent").post(event).then((result) => {
                deferred.resolve(result);
            }, (reason) => {
                deferred.reject(reason);
            })
            
            return deferred.promise;
        }

        getAllEvents() {
            var deferred = this.common.$q.defer();

            return deferred.promise;
        }

        updateStudentEvent(event: EventDetails) {
            var deferred = this.common.$q.defer<boolean>();
            this.Restangular.all("Calendar/updateStudentEvent").post(event).then((result) => {
                deferred.resolve(result);
            }, (reason) => {
                deferred.reject(reason);
            });
            return deferred.promise;
        }

        deleteStudentEvent(eventId: string) {
            var deferred = this.common.$q.defer<boolean>();

            this.Restangular.one("Calendar/deleteStudentEvent/" + eventId).get().then((result: boolean) => {
                if (result)
                    deferred.resolve(result);
            }, (reason) => {
                deferred.reject(reason);
                });

            return deferred.promise;
        }
    }

    angular.module("app").factory(CalendarServiceClient.serviceId, ["Restangular", "common", "$http", (Restangular: Restangular.IService, common: ICommonFactory, $http: ng.IHttpService) => new CalendarServiceClient(Restangular, common, $http)]);
}